module.exports = __webpack_public_path__ + "e7b4c1ac345e2374e751f7ea89783009.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 1057
// module chunks = 0